import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 4v3m-4 -3v6m8 -6v6","key":"svg-0"}],["path",{"d":"M12 18.5l-3 1.5l.5 -3.5l-2 -2l3 -.5l1.5 -3l1.5 3l3 .5l-2 2l.5 3.5l-3 -1.5","key":"svg-1"}]]

/**
 * IconMedal
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItbWVkYWwiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTEyIDR2M20tNCAtM3Y2bTggLTZ2NiIgLz4KICA8cGF0aCBkPSJNMTIgMTguNWwtMyAxLjVsLjUgLTMuNWwtMiAtMmwzIC0uNWwxLjUgLTNsMS41IDNsMyAuNWwtMiAybC41IDMuNWwtMyAtMS41IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/medal
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconMedal = createReactComponent('outline', 'medal', 'Medal', __iconNode);

export default IconMedal;